import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Images, FileText, Star, Settings, LogOut, ExternalLink, Leaf } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", end: true, label: "Tableau de bord", icon: LayoutDashboard, testid: "admin-nav-dashboard" },
  { to: "/admin/realisations", label: "Réalisations", icon: Images, testid: "admin-nav-realisations" },
  { to: "/admin/services", label: "Services", icon: Leaf, testid: "admin-nav-services" },
  { to: "/admin/demandes", label: "Demandes", icon: FileText, testid: "admin-nav-demandes" },
  { to: "/admin/avis", label: "Avis", icon: Star, testid: "admin-nav-avis" },
  { to: "/admin/site", label: "Site", icon: Settings, testid: "admin-nav-site" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${
      isActive ? "bg-cream/10 text-cream" : "text-cream/60 hover:text-cream hover:bg-cream/5"
    }`;

  return (
    <div className="min-h-screen bg-sand" data-testid="admin-layout">
      <aside className="hidden md:flex fixed inset-y-0 left-0 w-60 bg-deep text-cream flex-col p-4 z-40">
        <Link to="/admin" className="px-3 py-4" data-testid="admin-logo">
          <img src="/logo.png" alt="MARY SERVICES" className="h-7 w-auto invert" />
        </Link>
        <nav className="mt-4 space-y-1 flex-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={linkCls} data-testid={n.testid}>
              <n.icon className="h-4.5 w-4.5 h-[18px] w-[18px]" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-1 border-t border-cream/10 pt-3">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-cream/60 hover:text-cream transition-colors" data-testid="admin-view-site">
            <ExternalLink className="h-[18px] w-[18px]" />
            Voir le site
          </a>
          <button onClick={logout} className="w-full flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-cream/60 hover:text-cream transition-colors" data-testid="admin-logout">
            <LogOut className="h-[18px] w-[18px]" />
            Déconnexion
          </button>
        </div>
      </aside>

      <div className="md:pl-60">
        <header className="sticky top-0 z-30 bg-sand/90 backdrop-blur-md border-b border-line px-4 py-3 flex items-center justify-between md:justify-end">
          <Link to="/admin" className="md:hidden">
            <img src="/logo.png" alt="MARY SERVICES" className="h-6 w-auto" />
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-xs text-muted2 hidden sm:block">{user?.email}</span>
            <button onClick={logout} className="md:hidden inline-flex items-center gap-1.5 text-xs font-medium text-body2 border border-line rounded-full px-3 py-1.5" data-testid="admin-logout-mobile">
              <LogOut className="h-3.5 w-3.5" />
              Sortir
            </button>
          </div>
        </header>

        <nav className="md:hidden flex gap-1.5 overflow-x-auto px-3 py-2.5 border-b border-line bg-cream" aria-label="Navigation admin">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`${n.testid}-mobile`}
              className={({ isActive }) =>
                `shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-xs font-semibold transition-colors ${
                  isActive ? "bg-forest text-cream" : "text-body2 bg-sand"
                }`
              }
            >
              <n.icon className="h-3.5 w-3.5" />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <main className="p-4 sm:p-6 lg:p-10 max-w-6xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
